import React from 'react';
import { SLACK_DISCONNECT_WARNING, HIDE_SLACK_USERS } from './constants';
import { Button } from '@trello/nachos/button';

// Currently this is a dummy component. will implement this in Phase 2
export const HideSlackUsersPopOver: React.FunctionComponent = () => {
  return (
    <div>
      <p>{SLACK_DISCONNECT_WARNING}</p>
      <Button shouldFitContainer={true}>{HIDE_SLACK_USERS}</Button>
    </div>
  );
};
